/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".colored[_nghost-%COMP%]   .facebook-btn[_ngcontent-%COMP%], .colored   [_nghost-%COMP%]   .facebook-btn[_ngcontent-%COMP%]{color:#3b5998}.colored[_nghost-%COMP%]   .twitter-btn[_ngcontent-%COMP%], .colored   [_nghost-%COMP%]   .twitter-btn[_ngcontent-%COMP%]{color:#1da1f2}"];
export { styles as styles };
